/* @flow */

import { call, put, take, select } from 'redux-saga/effects'

import type { Action } from '../types'
import { API_LOGOUT_URL } from '../urls'
import { sagaPost } from '../fetch'
import {
  BadResponseError,
  SagaMalfunctionError,
  sagaHandleError,
  sessionStorageRemoveItem,
  localStorageRemoveItem,
} from '../helpers'

import { goToLogin, goToOldLogin } from '../stores/routing'
import { selectCurrentUser, unsetCurrentUserId } from '../stores/currentUser'
import { unsetCurrentSettings } from '../stores/currentSettings'

import { clearAutomatedPolls } from '../stores/polls/automated'
import { clearFeaturedPolls } from '../stores/polls/featured'
import { clearCursors } from '../stores/cursoredUrlsStore'
import { clearPollsStore } from '../stores/pollsStore'

import { AUTH_TOKEN, isToolUser, OPINARY_USER } from '../stores/usersStore'

import { setIsCurrentUserFetched } from '../stores/isCurrentUserFetched'

export const LOGOUT_BUTTON_CLICK: string = 'opinary/LOGOUT_BUTTON_CLICK'
export const LOGOUT_UNAUTHORIZED_USER: string =
  'opinary/LOGOUT_UNAUTHORIZED_USER'

export const logoutButtonClick = (): Action => ({ type: LOGOUT_BUTTON_CLICK })

export const logoutUnauthorizedUser = (): Action => ({
  type: LOGOUT_UNAUTHORIZED_USER,
})

export function* sagaLogoutButtonClick(): Generator<*, void, *> {
  const currentUser = yield select(selectCurrentUser)
  const response = yield call(sagaPost, API_LOGOUT_URL)
  if (response == null) throw new SagaMalfunctionError()
  if (![200, 204].includes(response.status)) {
    throw new BadResponseError(response)
  }

  // Remove token from storage
  yield call(sessionStorageRemoveItem, AUTH_TOKEN)
  yield call(localStorageRemoveItem, OPINARY_USER)

  // remove the session
  yield put(unsetCurrentUserId())
  yield put(unsetCurrentSettings())

  yield put(clearPollsStore())
  yield put(clearFeaturedPolls())
  yield put(clearAutomatedPolls())
  yield put(clearCursors())

  // clear potentially sensitive data from browser
  if (isToolUser(currentUser)) {
    goToLogin()
  } else {
    console.log('sagaLogoutButtonClick, redirecting to login')
    yield put(goToOldLogin())
  }
}

export function* sagaLogoutUnauthorizedUser(
  isLogoutButtonClicked: boolean
): Generator<*, void, *> {
  const currentUser = yield select(selectCurrentUser)

  yield call(sessionStorageRemoveItem, AUTH_TOKEN)
  yield call(localStorageRemoveItem, OPINARY_USER)

  yield put(setIsCurrentUserFetched(true))
  yield put(unsetCurrentUserId())

  if (isToolUser(currentUser)) {
    // goToLogin()
  } else {
    yield put(goToOldLogin())
  }
}

export function* sagaRepeatedlyLogoutButtonClick(): Generator<*, void, *> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    yield take(LOGOUT_BUTTON_CLICK)
    try {
      yield call(sagaLogoutButtonClick)
    } catch (err) {
      yield call(sagaHandleError, err)
    }
  }
}

export function* sagaRepeatedlyLogoutUnauthorizedUser(): Generator<*, void, *> {
  // eslint-disable-next-line no-constant-condition
  while (true) {
    yield take(LOGOUT_UNAUTHORIZED_USER)

    try {
      yield call(sagaLogoutUnauthorizedUser)
    } catch (err) {
      yield call(sagaHandleError, err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/logout.js